export default __webpack_public_path__ + "static/media/1001-0101.c4081b0d.svg";